import { render } from "./EventRegistrantsList.vue?vue&type=template&id=1919b6fc&scoped=true"
import script from "./EventRegistrantsList.vue?vue&type=script&lang=js"
export * from "./EventRegistrantsList.vue?vue&type=script&lang=js"

import "./EventRegistrantsList.vue?vue&type=style&index=0&id=1919b6fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1919b6fc"]])

export default __exports__